import React, { Component } from 'react';

import EditableInput from '../../EditableInput';

import endpoints from '../../../lib/endpoints';

const basicProfileKeys = [
  {
    title: 'Full Name',
    key: 'fullname',
    textType: 'inline',
  },
  {
    title: 'Introduction',
    key: 'about',
    textType: 'multiline',
  },
  {
    title: 'From',
    key: 'originally_from',
    textType: 'inline',
  },
  {
    title: 'Lives in',
    key: 'lives_in',
    textType: 'inline',
  },
  {
    title: 'Why do you love mountains?',
    key: 'why_mountains',
    textType: 'multiline',
  },
  {
    title: 'Email address',
    key: 'email_address',
    textType: 'inline',
  },
];

export default class BasicPannel extends Component {
  render() {
    const { isViewingOwnProfile, userData } = this.props;
    return (
      <div className="profile">
        {/* IF USER IS VIEWING OWN PROFILE RENDER WITH EDITORS ELSE JUST VIEWS */}
        {isViewingOwnProfile
          ? basicProfileKeys.map(item => {
              return this.renderWithEditor({
                title: item.title,
                key: item.key,
                value: userData[`${item.key}`],
                multiline: item.textType === 'multiline',
              });
            })
          : basicProfileKeys.map(item => {
              return this.renderView({
                title: item.title,
                key: item.key,
                value: userData[`${item.key}`],
              });
            })}
      </div>
    );
  }

  renderWithEditor = ({ title, key, value, multiline }) => {
    const { urlUserId, updateUserData } = this.props;
    return (
      <div className="tb-row" key={key}>
        <div className="key">{title}</div>
        <EditableInput
          endpoint={endpoints.profile.patchUserData(urlUserId)}
          patchKey={key}
          value={value}
          className="value"
          multiline={multiline}
          updateData={updateUserData}
        >
          <div className="value">{value}</div>
        </EditableInput>
      </div>
    );
  };

  renderView = ({ title, key, value }) => {
    return (
      <div className="tb-row" key={key}>
        <div className="key">{title}</div>
        <div className="value">{value}</div>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Profile/ProfilePannel/BasicPannel.jsx